module.exports = __webpack_public_path__ + "static/media/supportCarousal1.500b907f.svg";